import { render, staticRenderFns } from "./GeneralPublicInvoiceItem.vue?vue&type=template&id=32683a64"
import script from "./GeneralPublicInvoiceItem.vue?vue&type=script&lang=js"
export * from "./GeneralPublicInvoiceItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32683a64')) {
      api.createRecord('32683a64', component.options)
    } else {
      api.reload('32683a64', component.options)
    }
    module.hot.accept("./GeneralPublicInvoiceItem.vue?vue&type=template&id=32683a64", function () {
      api.rerender('32683a64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/payments/GeneralPublicInvoiceItem.vue"
export default component.exports